import classnames from 'classnames';
import React from 'react';

import './action-strip.scss';
import { ActionStripProps } from './types';

const ActionStrip: React.FC<ActionStripProps> = ({ className, children }) => (
  <div className={classnames('action-strip', className)}>{children}</div>
);

export default ActionStrip;
